// Login.js
import "./Login.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, CircularProgress, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoginIcon from "@mui/icons-material/Login";
import { toast } from "react-toastify";
import { loginUser } from "../../redux/authSlice";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({ email: "", password: "" });

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    // Basic validation
    if (!credentials.email || !credentials.password) {
      toast.error("الرجاء إدخال البريد الإلكتروني وكلمة المرور");
      return false;
    }

    // Dispatch login action and handle success/failure
    dispatch(loginUser({ url: "/loginAdmin", credentials }))
      .unwrap()
      .then(() => {
        // Only navigate on success
        navigate("/", { replace: true });
      })
      .catch(() => {
        // Error is already handled by API interceptor
      });

    return false;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <div className="login">
      <div className="right"></div>
      <div className="left">
        <form onSubmit={handleSubmit} noValidate>
          <TextField
            type="email"
            id="outlined-basic"
            variant="outlined"
            sx={{ width: "80%" }}
            required
            name="email"
            placeholder="الايميل"
            onChange={handleChange}
            onKeyPress={handleKeyPress}
          />
          <FormControl sx={{ width: "80%" }} variant="outlined">
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              required
              name="password"
              placeholder="كلمة المرور"
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              endAdornment={
                credentials.password.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            startIcon={
              loading ? (
                <CircularProgress className="circular-progress" size={24} />
              ) : (
                <LoginIcon style={{ color: "white" }} />
              )
            }
            sx={{ gap: "10px", minWidth: "160px" }}
            disabled={loading}
          >
            {loading ? "" : "تسجيل الدخول"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
